import styled from 'styled-components';
import { Card } from 'antd';
import { COLORS } from '../../../../../../../constants/colors';

export const PreviewContainer = styled.div`
  padding: 0px;
  padding-bottom: 100px;
  border-radius: 25px;
  overflow-y: auto;
  height: 97vh;
  width: 100%;
  background-color: ${({ theme }) => theme?.background_color || '#f5f5f5'};
`;

export const ProfileHeader = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 20px;
  margin-top: 20px;
  text-align: center;
  background-color: ${({ theme }) => theme?.card_color || 'initial'};

  h2 {
    margin-top: 10px;
    font-size: 24px;
    color: ${({ theme }) => theme?.card_text_color || 'white'};
  }

  p {
    margin-top: 10px;
    font-size: 16px;
    color: ${({ theme }) => theme?.card_text_color || 'white'};
  }
`;

export const ProductCard = styled(Card)`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 100%;
  padding: 15px;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
  box-shadow: ${({ theme }) => getShadowStyle(theme)};
  border-radius: ${({ theme }) =>
    theme?.card_style?.includes('slightly-rounded') ? '10px' :
      theme?.card_style?.includes('squared') ? '0' : '15px'};
  border: ${({ theme }) =>
    theme?.card_style?.includes('outline') ? `2px solid ${theme?.card_color || '#000'}` : 'none'};
  background-color: ${({ theme }) =>
    theme?.card_style?.includes('outline') ? 'transparent' : theme?.card_color || '#1c1c1c'};
  text-align: center;

  .product-content {
    display: flex;
    width: 100%;
    align-items: flex-start;
    margin-bottom: 20px;
  }

  .product-info {
    flex-grow: 1;
    padding-left: 15px;
    text-align: left;
  }

  .product-image {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 80px; /* Match Avatar size */
    height: 80px; /* Match Avatar size */
    border-radius: 10px;
  }

  h3 {
    margin: 0;
    font-size: 16px;
    color: ${({ theme }) => theme?.card_text_color || 'white'};
  }

  p {
    margin: 5px 0;
    color: ${({ theme }) => theme?.card_text_color || '#d3d3d3'};
  }

  .product-price {
    font-size: 14px;
    color: ${({ theme }) => theme?.card_text_color || '#000'};

    .amount {
      font-weight: 600;
    }
  }

  .product-button {
    margin-top: auto;
    width: 100%;
    min-height: 55px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    text-decoration: none;
    
    border-radius: ${({ theme }) => {
    if (theme?.button_style?.includes('completely-rounded')) return '27.5px';
    if (theme?.button_style?.includes('slightly-rounded')) return '10px';
    return '0';
  }};

    background-color: ${({ theme }) =>
    theme?.button_style?.includes('outline') ? 'transparent' : theme?.button_color || COLORS.$mainBlue} !important;

    border: ${({ theme }) =>
    theme?.button_style?.includes('outline') ? `2px solid ${theme?.card_color || COLORS.$mainBlue}` : 'none'} !important;

    color: ${({ theme }) =>
    theme?.button_style?.includes('outline') ? theme?.button_color || COLORS.$mainBlue : theme?.button_text_color || '#FFFFFF'} !important;

    transition: all 0.3s ease;

    &:hover {
      background-color: ${({ theme }) =>
    theme?.button_style?.includes('outline')
      ? theme?.button_color || COLORS.$mainBlue
      : `${theme?.button_color || COLORS.$mainBlue}dd`} !important;
      color: ${({ theme }) =>
    theme?.button_style?.includes('outline')
      ? 'transparent'
      : theme?.button_text_color || '#FFFFFF'} !important;
    }

    &:focus, &:active {
      background-color: ${({ theme }) =>
    theme?.button_style?.includes('outline') ? 'transparent' : theme?.button_color || COLORS.$mainBlue} !important;
      color: ${({ theme }) =>
    theme?.button_style?.includes('outline') ? theme?.button_color || COLORS.$mainBlue : theme?.button_text_color || '#FFFFFF'} !important;
      border-color: ${({ theme }) => theme?.button_color || COLORS.$mainBlue} !important;
    }
  }

  .button-text {
    flex-grow: 1;
    text-align: left;
    color: ${({ theme }) =>
    theme?.button_style?.includes('outline') ? theme?.button_color || COLORS.$mainBlue : theme?.button_text_color || '#FFFFFF'} !important;
    transition: color 0.3s ease;

    ${({ theme }) => theme?.button_style?.includes('outline') && `
      .product-button:hover & {
        color: ${theme?.button_text_color || '#FFFFFF'} !important;
      }
    `}
  }

  .product-button:hover .button-text {
    color: ${({ theme }) =>
    theme?.button_style?.includes('outline') ? theme?.button_text_color || '#FFFFFF' : theme?.button_text_color || '#FFFFFF'} !important;
  }

  .button-icon {
    margin-left: 10px;
    display: flex;
    align-items: center;
    transition: color 0.3s ease;

    svg {
      path {
        transition: stroke 0.3s ease;
        stroke: ${({ theme }) =>
    theme?.button_style?.includes('outline') ? theme?.button_color || COLORS.$mainBlue : theme?.button_text_color || '#FFFFFF'} !important;
      }
    }
  }

  .product-button:hover .button-icon {
    svg {
      path {
        stroke: ${({ theme }) =>
    theme?.button_style?.includes('outline') ? theme?.button_text_color || '#FFFFFF' : theme?.button_text_color || '#FFFFFF'} !important;
      }
    }
  }

  .ant-card-body {
    padding: 0px;
    width: 100%;
    border-radius: 15px;
  }
`;

export const SimpleProductCard = styled.div`
  display: flex;
  align-items: center; /* Center items vertically */
  width: 100%;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
  box-shadow: ${({ theme }) => getShadowStyle(theme)};
  border-radius: ${({ theme }) =>
    theme?.card_style?.includes('slightly-rounded')
      ? '10px'
      : theme?.card_style?.includes('squared')
      ? '0'
      : '17px'};
  border: ${({ theme }) =>
    theme?.card_style?.includes('outline')
      ? `2px solid ${theme?.card_color || '#000'}`
      : 'none'};
  background-color: ${({ theme }) =>
    theme?.card_style?.includes('outline')
      ? 'transparent'
      : theme?.card_color || '#f3f3f1'};
  cursor: pointer;
  transition: transform 0.2s;
  height: 75px;

  &:hover {
    transform: scale(1.02);
  }

  .block__card--pill {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center; /* Center items vertically */
    /* Remove justify-content: center; */
    padding: 10px;
    border: none;
    border-radius: ${({ theme }) =>
      theme?.card_style?.includes('slightly-rounded')
        ? '10px'
        : theme?.card_style?.includes('squared')
        ? '0'
        : '17px'};
    text-decoration: none;
    color: inherit;

    &:hover {
      background-color: ${({ theme }) =>
        theme?.card_style?.includes('outline')
          ? 'rgba(0,0,0,0.1)'
          : theme?.card_color
          ? `${theme.card_color}dd`
          : '#e0e0e0'};
    }
  }

  .block__image--pill {
    margin-right: 15px;
    display: flex;
    align-items: center;

    .base-preview-image {
      width: 55px;
      height: 55px;
      border-radius: 10px;
      object-fit: cover;
    }
  }

  .block__content {
    flex: 1;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center; /* Center text horizontally */
    justify-content: center; /* Center text vertically */
  }

  .block__spacer {
    width: 70px; /* Same width as the image, adjust if necessary */
    height: 70px; /* Same height as the image, adjust if necessary */
    /* This spacer takes up space equal to the image */
  }

  .block__text--pill {
    font-size: 14px;
    color: ${({ theme }) => theme?.card_text_color || 'black'};
  }

  .price-review {
    display: flex;
    align-items: center;

    .product-price {
      font-size: 14px;
      color: ${({ theme }) => theme?.card_text_color || '#000'};

      .amount {
        font-weight: 600;
      }
    }
  }
`;


export const CustomCloseButton = styled.button`
  position: fixed;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  border: 1px solid lightgray;
  border-radius: 50%;
  width: 54px;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
  z-index: 1000;
`;

export const CustomModalContent = styled.div`
  .ant-modal {
    max-width: 480px !important;
    max-height: 1024px !important;
  }

  .ant-modal-content {
    border-radius: 25px !important;
    background-color: black;
    padding: 7px !important; // Override padding
  }

  .ant-modal-body {
    padding: 5px !important;
    background-color: black;
  }

  .ant-modal-wrap {
    background-color: black;
  }
`;

export const SectionTitle = styled.div`
  text-align: center;
  font-weight: 700;
  font-size: 16px;
  line-height: 1.5;
  margin-bottom: 20px;
  color: ${({ theme }) => theme?.card_text_color || 'black'};
`;

export const ScrollableContainer = styled.div`
  display: flex;
  justify-content: center;
  overflow-x: auto;
  width: 100%;
  padding: 10px 0;
`;

export const SocialButtons = styled.div`
  display: flex;
  gap: 10px;

  a {
    text-decoration: none;
  }

  button {
    margin-right: 10px;
    &:last-child {
      margin-right: 0;
    }
  }
`;

// Template section
export const TemplateOneButton = styled.button`
  background-color: #FFCC66;
  color: white;
  border: none;
  border-radius: 25px;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 16px;

  &:hover {
    background-color: #FFB84D;
  }
`;

export const TemplateTwoButton = styled.button`
  background-color: #66CCFF;
  color: white;
  border: none;
  border-radius: 25px;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 16px;

  &:hover {
    background-color: #4DB8FF;
  }
`;

export const TemplateThreeButton = styled.button`
  background-color: #CC66FF;
  color: white;
  border: none;
  border-radius: 25px;
  padding: 10px 20px;
  cursor: pointer;
  font-size: 16px;

  &:hover {
    background-color: #B84DFF;
  }
`;

export const HighlightCard = styled(Card)`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 20px;
  margin-left: auto;
  margin-right: auto;
  box-shadow: ${({ theme }) => getShadowStyle(theme)};
  border-radius: ${({ theme }) =>
    theme?.card_style?.includes('slightly-rounded') ? '10px' :
      theme?.card_style?.includes('squared') ? '0' : '15px'};
  border: ${({ theme }) =>
    theme?.card_style?.includes('outline') ? `2px solid ${theme?.card_color || '#000'}` : 'none'};
  overflow: hidden;
  position: relative;
  padding: 0;

  .product-content {
    position: relative;
    width: 100%;
    height: 100%;
  }

  .highlight-image {
    width: 100%;
    object-fit: cover;
    display: block;
  }

  .highlight-gradient {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    padding: 17px;
    background: linear-gradient(to top, 
      rgba(0,0,0, 3) 0%, 
      rgba(0,0,0, 0.3) 60%, 
      rgba(0,0,0, 0) 100%
    );
  }

  .highlight-title {
    color: #fff;
    margin: 0;
    font-size: 24px;
  }

  .product-button {
    position: absolute;
    bottom: 20px;
    left: 20px;
    right: 20px;
    width: calc(100% - 40px);
    font-weight: bold;
    min-height: 55px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    text-decoration: none;
    border-radius: ${({ theme }) =>
    theme?.button_style?.includes('slightly-rounded') ? '10px' :
      theme?.button_style?.includes('squared') ? '0' : '15px'};
    background-color: ${({ theme }) =>
    theme?.button_style?.includes('outline') ? 'transparent' : theme?.button_color || COLORS.$mainBlue};
    border: ${({ theme }) =>
    theme?.button_style?.includes('outline') ? `2px solid ${theme?.button_color || COLORS.$mainBlue}` : 'none'};
    color: ${({ theme }) =>
    theme?.button_style?.includes('outline') ? theme?.button_color || COLORS.$mainBlue : theme?.button_text_color || '#FFFFFF'};

    &:hover {
      background-color: ${({ theme }) =>
    theme?.button_style?.includes('outline') ? 'rgba(0,0,0,0.1)' : COLORS.$mainBlueHover};
      color: ${({ theme }) => theme?.button_text_color || 'white'};
    }
  }

  .button-text {
    flex-grow: 1;
    text-align: left;
  }

  .button-icon {
    margin-left: 10px;
    display: flex;
    align-items: center;
  }

  .ant-card-body {
    padding: 0px;
    width: 100%;
  }
`;

export const VideoProductCard = styled(Card)`
  width: 100%;
  margin-bottom: 16px;
  border-radius: ${props => props.theme?.card_style === 'fill-slightly-rounded' ? '8px' : '0'};
  overflow: hidden;
  box-shadow: ${({ theme }) => getShadowStyle(theme)};

  .ant-card-body {
    padding: 0;
  }

  .video-content {
    position: relative;
    padding-top: 56.25%; // 16:9 aspect ratio
  }

  .ant-carousel {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .video-button {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 16px;
    text-decoration: none;
    transition: background-color 0.3s ease;

    &:hover {
      opacity: 0.9;
    }
  }

  .button-text {
    font-weight: 600;
  }

  .button-icon {
    display: flex;
    align-items: center;
  }
`;

export const VideoThumbnail = styled.div`
  width: 100%;
  height: 200px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const VideoInfo = styled.div`
  padding: 16px;

  h3 {
    margin: 0 0 8px;
    font-size: 16px;
    font-weight: 500;
  }

  p {
    margin: 0;
    font-size: 14px;
    color: #666;
  }
`;

export const VideoCarousel = styled.div`
  .slick-slide {
    padding: 0 4px;
  }

  .slick-prev, .slick-next {
    z-index: 1;
  }

  .slick-prev {
    left: 10px;
  }

  .slick-next {
    right: 10px;
  }
`;

const getShadowStyle = (theme) => {
  if (!theme?.shadow_color) return '0 4px 8px rgba(0, 0, 0, 0.1)';

  const hexToRgba = (hex, alpha = 1) => {
    const [r, g, b] = hex.match(/\w\w/g).map(x => parseInt(x, 16));
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };

  const softShadowColor = hexToRgba(theme.shadow_color, 0.1);
  const hardShadowColor = hexToRgba(theme.shadow_color, 0.5);

  switch (theme?.card_style) {
    case 'soft-shadow-squared':
    case 'soft-shadow-slightly-rounded':
      return `0 6px 12px ${softShadowColor}`;
    case 'hard-shadow-squared':
    case 'hard-shadow-slightly-rounded':
      return `3px 3px 0 ${hardShadowColor}`;
    case 'outline-squared':
    case 'outline-slightly-rounded':
      return 'none'; // No shadow for ghost buttons
    default:
      return `0 4px 8px ${softShadowColor}`;
  }
};